module.exports = __webpack_public_path__ + "img/examination-video-5.beb9d7fa.jpg";